<template>
  <section class="BVideo">
    <h2>{{ tabData.title }}</h2>

    <!-- :src="getImgUrl(v.resource)" -->
    <!-- src="https://data-file-platform.s3.ap-southeast-1.amazonaws.com/gvi-us-2024-06-12MTcxODE2MzI1NzE4MA%3D%3D.mp4" -->

    <video
      class="video-item"
      ref="videoRef1"
      :controls="false"
      :src="tabData?.introduceVideos[0]?.fileUrl"
      object-fit="fill"
      webkit-playsinline="true"
      playsinline="true"
      x5-playsinline="true"
      x-webkit-airplay="true"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
      muted
      autoplay
      loop
      preload="auto"
    />
    <!-- poster="https://www.greenvalleyintl.com/resource/firstPage/LiGrip_H300.png" -->
  </section>
</template>

<script setup>
const tabData = inject("tabData");
</script>

<style lang="less" scoped>
.BVideo {
  h2 {
    .fcf(36,#B9B9BB,600);
    text-align: center;
    margin-top: 80px;
    margin-bottom: 40px;
  }

  .video-item {
    width: 100%;
    // height: 100%;
    // object-fit: fill;
    // max-height: 500px;
  }
}

@media (max-width: 1024px) {
  .BVideo {
    h2 {
      .fcf(30,#B9B9BB,600);
    }

    .video-item {
    }
  }
}
</style>
